import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const SIDE_PANEL_KEY = 'cm-side';

/** UI-only layout state shared by the v2 community shell, sidebar and chat. */
@Injectable({ providedIn: 'root' })
export class CommunityLayoutService {
  /** Phone only: spaces list shown over the chat. */
  readonly railOpen$ = new BehaviorSubject<boolean>(false);

  setRailOpen(open: boolean): void {
    this.railOpen$.next(open);
  }

  /** Remembered right-panel choice; null when the viewer never chose. */
  getSidePanelPref(): boolean | null {
    try {
      const v = localStorage.getItem(SIDE_PANEL_KEY);
      return v === null ? null : v === '1';
    } catch {
      return null;
    }
  }

  setSidePanelPref(open: boolean): void {
    try {
      localStorage.setItem(SIDE_PANEL_KEY, open ? '1' : '0');
    } catch {
      // storage unavailable; the panel still toggles for this visit
    }
  }
}
